import React, { useEffect, useState } from "react";
import {
    CardContainer,
    CardProfile,
    ImgWrap,
    Img,
    CardH2,
    CardH3,
    CardSpan,
    CardInfo,
    CardH1,
    CardP,
    User,
    Button,
    CardName,
} from "./CardElements";
import { IoTelescopeOutline } from "react-icons/io5";
import { ImCross } from "react-icons/im";

const Card = ({
    img,
    name,
    institution,
    LSST,
    title,
    description,
    invitado,
}) => {
    const [avatar, setAvatar] = useState();
    const [moreInfo, setMoreInfo] = useState(false);

    useEffect(() => {
        const getinitials = () => {
            if (name) {
                if (!img) {
                    const names = name?.toUpperCase().split(" ");
                    const first_name = names[0].at(0);
                    const last_name = names[1].at(0);
                    const result = first_name + last_name;
                    setAvatar(result);
                } else {
                    setAvatar("Error");
                }
            }
        };
        getinitials();
    }, [name, avatar, img]);

    return (
        <CardContainer invitado={invitado}>
            {moreInfo ? (
                <CardInfo>
                    <ImCross
                        onClick={() => setMoreInfo(false)}
                        style={{ cursor: "pointer" }}
                    />
                    <CardH1> {title && title} </CardH1>
                    <CardP> {description && description} </CardP>
                </CardInfo>
            ) : (
                <CardProfile>
                    {img ? (
                        <ImgWrap>
                            <Img src={img} alt={name} />
                        </ImgWrap>
                    ) : (
                        <User>
                            <h1> {avatar} </h1>
                        </User>
                    )}
                    <CardName>
                        <CardSpan invitado={invitado}>
                            {invitado && "Invitado"}
                        </CardSpan>
                        <CardH2> {name && name} </CardH2>
                    </CardName>

                    <CardH3>
                        <IoTelescopeOutline /> {institution && institution}
                    </CardH3>
                    {LSST && (
                        <CardSpan LSST={LSST}>
                            <IoTelescopeOutline /> <span> {LSST} </span>
                        </CardSpan>
                    )}

                    {title && (
                        <Button onClick={() => setMoreInfo(true)}>
                            Ver ponencia
                        </Button>
                    )}
                </CardProfile>
            )}
        </CardContainer>
    );
};

export default Card;
